import { DateSelectorType } from '../enums';
import { isSameDay } from 'date-fns';
import { Dispatch, SetStateAction } from 'react';

/**
 * If the type is 'today' but the date isn't today, reset the type to 'date'.
 */
export const clearDateSelector = (
  date: Date | undefined,
  setDate: Dispatch<SetStateAction<Date | undefined>>,
  type: DateSelectorType | undefined,
  setType: Dispatch<SetStateAction<DateSelectorType | undefined>>
) => {
  if (
    type === DateSelectorType.today &&
    date !== undefined &&
    !isSameDay(date, Date.now())
  ) {
    setType(DateSelectorType.date);
  }
  setDate(date);
};
